import { Link } from "react-router-dom";
import type { PlotItem } from "@/types/film";

export default function PlotCard({ item }: { item: PlotItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.chapter} ${item.title} 蜜桃成熟时3D 剧情介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
          {item.chapter}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <span className="mb-2 text-xs font-medium tracking-wide text-primary-700">{item.act}</span>
        <h3 className="mb-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mb-4 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <span className="flex items-center gap-1 text-sm font-medium text-accent-600">
          查看剧情
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}